import { setStyleAttribute } from '../misc'

export class ModalWindow {
  wrapper: HTMLDivElement
  background: HTMLDivElement
  window: HTMLDivElement
  closeButton: HTMLButtonElement

  constructor() {
    this.wrapper = document.createElement('div')
    this.hide()

    this.background = document.createElement('div')
    this.window = document.createElement('div')
    this.closeButton = document.createElement('button')

    setStyleAttribute(this.window, {
      position: 'fixed',
      width: '500px',
      height: '280px',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      'background-color': 'white',
      opacity: '1',
    })

    setStyleAttribute(this.background, {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      'background-color': 'black',
      opacity: '0.5',
    })

    setStyleAttribute(this.closeButton, {
      float: 'right',
      height: '20px',
      'min-height': '20px',
      width: '20px',
      'min-width': '20px',
      padding: '0',
      border: 'none',
      margin: '10px',
      // Close icon in svg
      background:
        'url("data:image/svg+xml,%3Csvg%20fill%3D%22%23000000%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20viewBox%3D%220%200%2050%2050%22%20width%3D%2250px%22%20height%3D%2250px%22%3E%3Cpath%20d%3D%22M%207.71875%206.28125%20L%206.28125%207.71875%20L%2023.5625%2025%20L%206.28125%2042.28125%20L%207.71875%2043.71875%20L%2025%2026.4375%20L%2042.28125%2043.71875%20L%2043.71875%2042.28125%20L%2026.4375%2025%20L%2043.71875%207.71875%20L%2042.28125%206.28125%20L%2025%2023.5625%20Z%22%2F%3E%3C%2Fsvg%3E")',
      'background-size': 'contain',
      opacity: '0.5',
    })

    this.closeButton.addEventListener('click', () => this.hide())
    this.closeButton.addEventListener('mouseenter', () => (this.closeButton.style.opacity = '1'))
    this.closeButton.addEventListener('mouseout', () => (this.closeButton.style.opacity = '0.5'))

    this.window.appendChild(this.closeButton)
    this.wrapper.appendChild(this.background)
    this.wrapper.appendChild(this.window)
  }

  hide(): void {
    setStyleAttribute(this.wrapper, { display: 'none' })
  }

  show(): void {
    setStyleAttribute(this.wrapper, { display: 'block' })
  }

  remove(): void {
    this.window.remove()
    this.background.remove()
    this.wrapper.remove()
  }
}
